module.exports = __webpack_public_path__ + "img/forgot-password-v2-dark.53b97761.svg";